<template>
  <div id="DropdownActions">
    <v-menu offset-y>
      <template #activator="{ on: onMenu }">
        <v-tooltip top>
          <template #activator="{ on: onTooltip }">
            <v-icon
              style="font-size: 30px; position: relative; top: 4px"
              color="black"
              dense
              large
              v-on="{ ...onMenu, ...onTooltip }"
            >
              mdi-menu
            </v-icon>
          </template>

          <span>Ver mais ações</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, indexDropdown) in itemsDropdown"
          :key="indexDropdown"
          @click="actionsDropdown(indexDropdown)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "DropdownActions",
  props: {
    itemsDropdown: {
      default: () => [],
      type: Array,
    },
  },
  methods: {
    actionsDropdown(indexDropdown) {
      this.$emit("actionsDropdown", indexDropdown);
    },
  },
};
</script>

<style></style>
